import React from 'react';
import BackArrowNav from 'common/icons/BackArrowNav';

import {
    BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
    BRAND_LIBRARY_BUTTON_HOVER_COLOR,
    BRAND_LIBRARY_BODY_TEXT,
} from 'common/constants/brandLibrary';

import { getEventPageUrl } from 'common/components/TouchpointEditor/utils';
import Link from 'common/components/TouchpointEditor/components/TouchpointNodes/Link';

export default function BackButtonLink(props) {
    // eslint-disable-next-line react/prop-types
    return <Link BeforeIcon={BackArrowNav} {...props} meta={{ ...props.meta, href: getEventPageUrl() }} />;
}

BackButtonLink.splash = {
    ...Link.splash,
    defaultProps: {
        ...Link.splash.defaultProps,
        meta: {
            ...Link.splash.defaultProps.meta,
            content: 'Back to the event page',
        },
        styles: {
            ...Link.splash.defaultProps.styles,
            fontFamily: BRAND_LIBRARY_BODY_TEXT,
            fontSize: 16,
            fontColor: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
            fontColorHover: BRAND_LIBRARY_BUTTON_HOVER_COLOR,
        },
    },
};
